import { AppStorageKeys } from "../../Constants/Constants";
import SessionStorage from "../../Constants/SessionStorage";
const qs = require("qs");
const axios = require("axios");

const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);

const CLIENT_ID = ENV_VARS.CLIENT_ID;
const CLIENT_SECRET = ENV_VARS.CLIENT_SECRET;

const AUTH_URL = ENV_VARS.AUTH_URL;
const AUTH_PORT = ENV_VARS.AUTH_PORT;
const AUTH_PATH_PREFIX = ENV_VARS.AUTH_PATH_PREFIX ?? "/auth";
const AUTH_API_PATH = (partner) =>
  `${AUTH_PATH_PREFIX}/realms/${partner}/protocol/openid-connect/token`;

export const AuthService = {
  login,
};

async function login(authUrl, username, password, partner) {
  console.log("auth envs:", AUTH_URL, AUTH_PORT, authUrl);
  console.log("client envs:", CLIENT_ID, CLIENT_SECRET);
  const clientSecret = CLIENT_SECRET[partner];
  const authURL = AUTH_URL || authUrl;
  const data = qs.stringify({
    grant_type: "password",
    client_id: CLIENT_ID,
    client_secret: clientSecret,
    username: username,
    password: password,
  });
  const config = {
    method: "post",
    url: authURL + ":" + AUTH_PORT + AUTH_API_PATH(partner),
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: data,
  };

  const response = {
    code: 500,
    status: "Failure",
    message: "error authenticating user!",
  };

  try {
    const loginRes = await axios(config);
    console.log("login response:", loginRes);
    const userData = loginRes?.data;
    if (userData) {
      console.log("login success:", userData);
      response.code = 200;
      response.status = "Success";
      response.message = userData;
    }
  } catch (error) {
    console.log("login failed:", error);
    if (error.response && error.response.status === 401) {
      response.code = 401;
      response.message = "Invalid credentials!";
    }
  }
  return response;
}
